import { NavLink, Outlet } from 'react-router-dom';
import AppHeader from './layout/AppHeader.jsx';

const NAV = [
  { to: '/crm/pipeline', label: 'Pipeline' },
  { to: '/crm/deals', label: 'Deals' },
  { to: '/crm/contacts', label: 'Contacts' },
  { to: '/crm/companies', label: 'Companies' },
];

export default function CrmShell() {
  return (
    <div className="hr-shell">
      <AppHeader />
      <div className="hr-body">
        <aside className="hr-side">
          <div className="hr-side-title">CRM</div>
          <ul>
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} className={({ isActive }) => isActive ? 'active' : ''}>{n.label}</NavLink>
              </li>
            ))}
          </ul>
        </aside>
        <main className="hr-main"><Outlet /></main>
      </div>
    </div>
  );
}
